import { Pipe, PipeTransform } from "@angular/core";
@Pipe({
  name: "GetUserActivityNameByKey",
})
export class GetUserActivityNameByKey implements PipeTransform {
  transform(value: any, args: any[]): any {
    return UserActivities[value];
  }
}

enum UserActivities {
  activeIOSUser = "Logged-in IOS User",
  activeUsers = "Registered Active Users",
  activeWebUser = "Logged-in Web User",
  inactiveUsers = "Registered Inactive Users",
  totalUsers = "Total Registered Users",
  usersLoggedInToday = "Users Logged In Today",
  usersNotLoggedInRecently = "Users Not Logged In Recently",
}
